import { render, staticRenderFns } from "./membership-summary.vue?vue&type=template&id=52b79558&scoped=true"
import script from "./membership-summary.vue?vue&type=script&lang=js"
export * from "./membership-summary.vue?vue&type=script&lang=js"
import style0 from "./membership-summary.vue?vue&type=style&index=0&id=52b79558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b79558",
  null
  
)

export default component.exports